import React, { Component } from 'react';
import {ReactComponent as CloseIcon} from './icons/path.svg';
import { Link } from 'react-router-dom'
import Tabs from '../Tabs';
import classNames from 'classnames';

import { getCompanyType, getUser } from 'Utils/storage';
import { SEEKER_VALUE } from 'Constants/commonConstants';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import Moment from 'moment';
export default class DashboardTopNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: 0,
            endDate: 0,
            focusedInput:false
        };
        
    }
    handleDateChange(startDate, endDate) {
        this.setState({
            startDate: startDate ? Moment(startDate) : 0,
            endDate: endDate ? Moment(endDate) : 0
        },()=>{
            this.props.onRfqSearchByDate(startDate,endDate);
        }
        );
    }
    onClearSearchDate=()=> {
        this.setState({
            startDate:0,
            endDate:0 
        },()=>{this.props.onCancelDate();
        }
        );
    }

    render() {
        const {
            changeRfqStatusFilter,
            rfqStatusFilter,
            tabFilter,
            onKeyPressOnSearch,
            searchString,
            onSearchStringChange,
            hideActions,
            searchPlaceHolder,
            showFilters,
            onCancel,
            contracting,
            isAdminView,
        } = this.props;
        const companyType = getCompanyType();
        const actions = getUser().actions;
        const enableCreateRFQ = (actions || []).find(action => action.id == 1);
        return (
            <div className={classNames("flex d-block dashboard-top-nav-container flex-between box-shadow pl-50 pr-20 pt-15 pf col-1 bg-white p-0 w-61 z-2",{
                'ht-65' : hideActions 
            })}>
                <div className="flex flex-middle flex-basis-17p pt-0 mb-10">
                    <CloseIcon />
                    <div className="pl-10 fSemibold fs-22 theme-color">RFQs</div>
                </div>
                <div className="tabs-zoomed tabs-lg ml--3">
                {
                    !hideActions && showFilters && <Tabs className="mb-10 fs-16" tabs={tabFilter} activeTabId={rfqStatusFilter} selectTab={changeRfqStatusFilter}/>
                }
                </div>
                {
                    !hideActions && contracting && 

                    <div className="flex flex-middle flex-around ml-10 mb-10 tabs-zoomed">
                        <span className="clearable wt-60p">
                            <DateRangePicker
                                startDate={this.state.startDate}
                                startDateId="startDate"
                                endDate={this.state.endDate}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => {this.handleDateChange(startDate, endDate) }}
                               focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                                isOutsideRange={() => false}
                            />
                            { companyType === SEEKER_VALUE ?this.state.startDate!=0 && this.state.endDate!= 0 && 
                       
                       <span 
                           className="clear_date_seeker" 
                           onClick={this.onClearSearchDate}
                       >&times;</span>:this.state.startDate!=0 && this.state.endDate!= 0 && 
                  
                       <span 
                           className="clear_date_provider" 
                           onClick={this.onClearSearchDate}
                       >&times;</span>
                   }
                        </span> 
                        
                   
						  <span className="TabClearable">
                        <input placeholder={searchPlaceHolder || "Search RFQ And Contracts"}
                                type="text" 
                                className="br-20 ht-40 bg-gray search"
                                value={searchString}
                                onChange={onSearchStringChange}
                                onKeyPress={onKeyPressOnSearch}
                            />
                            {searchString && searchString.length > 0 && 
                            <span 
                                className="clearable__clear" 
                                onClick={onCancel}
                            >&times;</span>
                        }
                     </span> 
						  
                        
                        {!isAdminView && enableCreateRFQ && companyType === SEEKER_VALUE && contracting && <Link to = "/rfq/type" className="flex flex-middle flex-center ht-40 br-20 white-color bg-theme fs-14 fSemibold pl-15 pr-15 lh-18"> New&nbsp;RFQ </Link>}
                    </div>
                }
                
            </div>
        )
    }
}
